import {
  PUBLISH,
  EMAIL_WITH_OUTLOOK,
  PUBLISH_SUBMIT,
  SCHEDULE_EMAIL,
  SAVE_PUBLISH_STATE,
  PROMO_CODES,
} from "../../constants/actionTypes";
import { IPublishAction, IPublishState, IPublishSenderEmails } from "./interfaces";

const publishInitialState: IPublishState = {
  openPublishedScreen: false,
  openPublishedConfirmation: false,
  showNotPremiumUserPopup: true,
  disableSendFrom: false,
  redirectionURL: "",
  outlookSenderEmailAddress: "",
  outlookSenderName: "",
  callbackSuccessState: "",
  isAuthorized: false,
  outlookRemainingEmails: 500,
  userName: "",
  userEmail: "",
  data: {
    xiq_internal_user: false,
    sender_emails: Array<IPublishSenderEmails>(),
    mail_to: [],
    sender_name: "",
    subject: "",
    asset_name: "",
    free_user: true,
  },
  loaded: false,
  loading: true,
  outlookRoute: false,
  promoCodes: [],
  promoCodesLoading: false,
  emailWithOutlookLoading: false,
  connectionError: false,
  outlookRoutePublishAPI: false,
  exportPromoCodesSuccess: false,
};

export const publishReducer = (state = publishInitialState, action: IPublishAction) => {
  const new_state = { ...state };
  switch (action.type) {
    case PUBLISH.OPEN:
      new_state.openPublishedScreen = true;
      //* Do not use window.location.href unnecessarily instead use history.push from react-router
      // window.location.href = "/publish?version_id="+getVersionId()
      return new_state;
    case PUBLISH.CLOSE:
      new_state.openPublishedScreen = false;
      return new_state;
    case PUBLISH.SEND_CONFIRMATION_OPEN:
      new_state.openPublishedConfirmation = true;
      return new_state;
    case PUBLISH.SEND_CONFIRMATION_CLOSE:
      new_state.openPublishedConfirmation = false;
      return new_state;
    case PUBLISH.RESET_SHOW_NOT_PREMIUM:
      new_state.showNotPremiumUserPopup = false;
      return new_state;

    case PUBLISH.LOAD:
      // new_state.showNotPremiumUserPopup = false;
      new_state.loading = true;
      new_state.loaded = false;
      return new_state;

    case PUBLISH.LOAD_SUCCESS:
      // new_state.showNotPremiumUserPopup = false;
      new_state.data = { ...action.payload, free_user: true };
      new_state.outlookSenderEmailAddress = action.payload.outlook_sender_email_address;
      new_state.outlookSenderName = action.payload.outlook_sender_name;
      new_state.outlookRoutePublishAPI = action.payload.outlook_route;
      new_state.loading = false;
      new_state.loaded = true;
      return new_state;

    case PUBLISH.OUTLOOK_ROUTE_SUCCESS:
      new_state.outlookRoute = true;
      return new_state;

    case PUBLISH.LOAD_FAIL:
      // new_state.showNotPremiumUserPopup = false;
      new_state.loading = false;
      new_state.loaded = false;
      return new_state;

    case PUBLISH.RESET_LOADED:
      new_state.loaded = false;
      return new_state;

    //email send cases
    case PUBLISH_SUBMIT.LOAD:
      new_state.showNotPremiumUserPopup = !action.isPremium || false;
      return new_state;

    case PUBLISH_SUBMIT.SUCCESS:
      // new_state.showNotPremiumUserPopup = false;
      new_state.openPublishedConfirmation = true;
      return new_state;

    case PUBLISH_SUBMIT.FAIL:
      // new_state.showNotPremiumUserPopup = false;
      return new_state;

    case SAVE_PUBLISH_STATE.LOAD:
      return new_state;

    case SAVE_PUBLISH_STATE.SUCCESS:
      new_state.data.sender_name = action.payload.sender_name;
      new_state.data.subject = action.payload.subject;
      return new_state;

    case SAVE_PUBLISH_STATE.UPDATE:
      if (action.payload.sender_name) {
        new_state.data.sender_name = action.payload.sender_name;
      }
      if (action.payload.subject) {
        new_state.data.subject = action.payload.subject;
      }
      return new_state;

    case SAVE_PUBLISH_STATE.FAIL:
      return new_state;

    //email schedule cases
    case SCHEDULE_EMAIL.LOAD:
      new_state.showNotPremiumUserPopup = !action.isPremium || false;
      return new_state;

    case SCHEDULE_EMAIL.SUCCESS:
      // new_state.showNotPremiumUserPopup = false;
      new_state.openPublishedConfirmation = true;
      return new_state;

    case SCHEDULE_EMAIL.FAIL:
      // new_state.showNotPremiumUserPopup = false;
      return new_state;

    case EMAIL_WITH_OUTLOOK.LOAD:
      new_state.emailWithOutlookLoading = true;
      return new_state;

    case EMAIL_WITH_OUTLOOK.SUCCESS:
      const { url, is_authorized, outlook_remaining_emails, user_name, user_email } = action.payload;
      new_state.redirectionURL = url;
      new_state.isAuthorized = is_authorized;
      new_state.outlookRemainingEmails = outlook_remaining_emails;
      new_state.userName = user_name;
      new_state.userEmail = user_email;
      new_state.emailWithOutlookLoading = false;
      return new_state;

    case EMAIL_WITH_OUTLOOK.FAIL:
      new_state.emailWithOutlookLoading = false;
      new_state.connectionError = true;
      return new_state;

    case EMAIL_WITH_OUTLOOK.RESET_ERROR:
      new_state.connectionError = false;
      return new_state;

    case EMAIL_WITH_OUTLOOK.SEND_FROM_DISABLE:
      new_state.disableSendFrom = true;
      return new_state;

    case EMAIL_WITH_OUTLOOK.SET_CALLBACK_STATE:
      new_state.callbackSuccessState = action.payload.callback_success_state;
      new_state.isAuthorized = action.payload.callback_success_state === "true" ? true : false;
      return new_state;

    case EMAIL_WITH_OUTLOOK.RESET:
      new_state.disableSendFrom = false;
      new_state.outlookSenderEmailAddress = "";
      new_state.isAuthorized = false;
      new_state.outlookRoute = false;
      new_state.userName = "";
      new_state.userEmail = "";
      new_state.callbackSuccessState = "";
      return new_state;

    case PROMO_CODES.LOAD:
      new_state.promoCodesLoading = true;
      return new_state;

    case PROMO_CODES.SUCCESS:
      const { promoCodes } = action;
      if (promoCodes) new_state.promoCodes = promoCodes;
      new_state.promoCodesLoading = false;
      return new_state;

    case PROMO_CODES.FAIL:
      new_state.promoCodesLoading = false;
      return new_state;

    case PROMO_CODES.EXPORT_SUCCESS:
      new_state.exportPromoCodesSuccess = action.promoCodesExportSuccess ? action.promoCodesExportSuccess : false;
      return new_state;

    default:
      return state;
  }
};
